import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-rating-modal',
  templateUrl: './rating-modal.component.html',
  styleUrls: ['./rating-modal.component.scss']
})


export class RatingModalComponent  {
  selectedRating = 0;
  hoverRating = 0;
  comment = '';
  showModal = false;
  isFirstTime = true;

  @Output() ratingSubmitted = new EventEmitter<{ rating: number; comment: string , isFirstTime: boolean}>();

  open(data?: any) {
    document.body.classList.add('no-scroll');
    this.showModal = true;
    console.log('open', data);
    if(data) {
      this.isFirstTime = false;
      this.selectedRating = data.userRating || 0;
      this.hoverRating = data.userRating || 0;
      this.comment = data.userComment || '';
    }
  }

  close() {
    document.body.classList.remove('no-scroll');
    this.showModal = false;
    this.selectedRating = 0;
    this.hoverRating = 0;
    this.comment = '';
  }

  setRating(value: number) {
    this.selectedRating = value;
  }

  setHover(value: number) {
    this.hoverRating = value;
  }

  resetHover() {
    this.hoverRating = 0;
  }

  submit() {
    this.ratingSubmitted.emit({ rating: this.selectedRating, comment: this.comment,  isFirstTime: this.isFirstTime });
    this.close();
  }
}
